"use client";

import { useTheme } from "next-themes";
import { useSyncExternalStore } from "react";

const ORDER = ["light", "dark", "cloud"] as const;
type Mode = (typeof ORDER)[number];

const LABEL: Record<Mode, string> = {
  light: "Açık tema",
  dark: "Koyu tema",
  cloud: "Bulut teması",
};

const mountedSubscribe = () => () => {};
const mountedGetSnapshot = () => true;
const mountedGetServerSnapshot = () => false;

function SunIcon() {
  return (
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
    </svg>
  );
}

function CloudIcon() {
  return (
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#4EB5A9"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M7.5 18h9.5a3.5 3.5 0 0 0 .3-7 5 5 0 0 0-9.6-1.3A3.75 3.75 0 0 0 7.5 18Z" />
    </svg>
  );
}

export function ThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const mounted = useSyncExternalStore(
    mountedSubscribe,
    mountedGetSnapshot,
    mountedGetServerSnapshot,
  );

  if (!mounted) {
    return (
      <span
        className="inline-block h-9 w-9 shrink-0 rounded-full border border-border/60 bg-muted/15"
        aria-hidden
      />
    );
  }

  const raw = theme === "system" ? resolvedTheme : theme;
  const current: Mode = (ORDER as readonly string[]).includes(raw ?? "")
    ? (raw as Mode)
    : "light";
  const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length];

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={`${LABEL[next]}na geç`}
      title={LABEL[current]}
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-foreground transition-colors hover:bg-card focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground/30 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
    >
      {current === "light" ? <SunIcon /> : current === "dark" ? <MoonIcon /> : <CloudIcon />}
    </button>
  );
}
